import ProductCode from "@components/ProductCode";
import styles from "./styles.module.scss";
import { Rating } from "../../../Rating";
import classNames from "classnames";
import { Product } from "@services/amazon/products/types";

interface CompareWidgetProps {
  compared: Product[];
  whatIfCompare: boolean;
  setCompareModal: (value: boolean) => void;
  setWhatIfCompare?: (value: boolean) => void;
}

export const CompareWidget = ({
  compared,
  whatIfCompare,
  setCompareModal,
  setWhatIfCompare,
}: CompareWidgetProps) => {
  if (!compared || compared.length === 0) return null;
  const handleToggle = () =>
    setWhatIfCompare && setWhatIfCompare(!whatIfCompare);

  return (
    <div className={styles.compareWidget}>
      <div className={styles.compareRow}>
        <div className={styles.compared}>
          <img
            src={compared[0].image_link}
            alt={compared[0].item_name}
            className={styles.comparedImage}
          />
          <div className={styles.comparedInfo}>
            <span className={styles.comparedName}>{compared[0].item_name}</span>
            <Rating rating={4.5} starSize="sm" />
            <ProductCode code={compared[0].asin ?? ""} />
          </div>
        </div>

        {compared.length > 1 &&
          (compared.length < 3 ? (
            <div className={styles.compared}>
              <img
                src={compared[1].image_link}
                alt={compared[1].item_name}
                className={styles.comparedImage}
              />
              <div className={styles.comparedInfo}>
                <span className={styles.comparedName}>
                  {compared[1].item_name}
                </span>
                <Rating rating={4.5} starSize="sm" />
                <ProductCode code={compared[1].asin ?? ""} />
              </div>
            </div>
          ) : (
            <div className={classNames(styles.compared, styles.comparedList)}>
              {compared.slice(1).map((item) => (
                <div className={styles.itemRow} key={item.asin}>
                  <img
                    src={item.image_link}
                    alt={item.item_name}
                    className={styles.comparedImage}
                  />
                  <span className={styles.comparedName}>{item.item_name}</span>
                  <ProductCode code={item.asin ?? ""} />
                  <Rating rating={4.5} starSize="sm" />
                </div>
              ))}
            </div>
          ))}
      </div>
      <div className={styles.actions}>
        <button
          type="button"
          className={classNames("btn", styles.switch, {
            [styles.back]: whatIfCompare,
          })}
          onClick={handleToggle}
        >
          {whatIfCompare ? "back to as is mode" : "switch to What if mode"}
        </button>
        <button
          type="button"
          className="btn compare"
          onClick={() => setCompareModal(true)}
        >
          Compare with another asin
        </button>
      </div>
    </div>
  );
};
